import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Dialog } from "primereact/dialog";
import Langs from "../../app/lang/langs";
import { showErrorToast } from "../../app/utils/helpers";
import {
    getCollabContract,
    addCollabContract,
    typeOfContractOptions
} from "../../components/collabs/collabsSlice"
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import moment from 'moment'
import styles from './CollabsView.module.css'

export default function AddContractModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const companies = useSelector((state) => state.collabs.companies)
    const allCollabs = useSelector((state) => state.collabs.allCollabsList)

    const [newContract, setNewContract] = useState({})

    const handleAddContract = async () => {
        try {
            const actionResponse = await dispatch(
                addCollabContract({
                    collab_contract: {
                        id_collab: props.collabDetails.id,
                        id_company: newContract.id_company,
                        type_contrat: newContract.type_contrat,
                        entree_date: newContract.entree_date ? moment(newContract.entree_date).format("YYYY-MM-DD HH:mm:ss") : null,
                        sortie_date: newContract.sortie_date ? moment(newContract.sortie_date).format("YYYY-MM-DD HH:mm:ss") : null,
                        responsable_contractuel: newContract.responsable_contractuel
                    }
                })
            ).unwrap()
            if (actionResponse.responseData?.error == "conflict") {
                showErrorToast("CONTRACT_CONFLICT_ERROR")
            } else if (actionResponse.responseData?.status) {
                dispatch(getCollabContract({ id_collab: props.collabDetails.id }))
                props.onHide()
                setNewContract({})
            }
        } catch (error) {
            console.error("Error adding contract:", error)
            showErrorToast()
        }
    }

    const isFormValid = () => {
        return (
            newContract.type_contrat &&
            newContract.entree_date
        )
    }

    const footerView = () => {
        return <Row className="py-3 d-flex justify-content-space-center">
            <Col lg={4}></Col>
            <Col lg={4}>
                <PrimaryButton
                    onClick={handleAddContract}
                    className=""
                    title={<Langs str="ADD" />}
                    active={isFormValid()}
                    color="green"
                />
            </Col>
            <Col lg={4}></Col>
        </Row>
    }

    const getNearestFuturContractStartDate = () => {
        let nearestDate
        if (props.collabContract && props.collabContract.upcomingContracts)
            props.collabContract.upcomingContracts.map(c => {
                if (nearestDate && moment(c.entree_date).isAfter(nearestDate)) {
                    return
                }
                if (c.entree_date) nearestDate = moment(c.entree_date)
            })
        return nearestDate && nearestDate.toDate()
    }

    const handleEntreeDateChange = (e) => {
        const selectedDate = e.value ? new Date(e.value) : null
        setNewContract((prev) => ({
            ...prev,
            entree_date: selectedDate
        }))
    }

    const handleSortieDateChange = (e) => {
        const selectedDate = e.value ? new Date(e.value) : null
        setNewContract((prev) => ({
            ...prev,
            sortie_date: selectedDate
        }))
    }

    return (
        <Dialog
            visible={props.show}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                props.onHide()
                setNewContract({})
            }}
            header={<Langs str="ADD_CONTRACT" />}
            footer={footerView()}
            draggable={false}
            dismissableMask={false}
        >
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="COMPANY" /></label>
                </Col>
                <Col lg={9} className="mb-1 pe-3">
                    <Dropdown
                        className={styles.dropdown}
                        filter
                        id="id_company"
                        value={newContract.id_company}
                        options={companies}
                        onChange={(e) =>
                            setNewContract((prev) => ({
                                ...prev,
                                id_company: e.value,
                            }))
                        }
                        placeholder="Sélectionner une entreprise"
                    />
                </Col>
            </Row>

            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="CONTRACT_TYPE" /></label>
                </Col>
                <Col lg={9} className="mb-1 pe-3">
                    <Dropdown
                        className={styles.dropdown}
                        filter
                        id="type_contrat"
                        value={newContract.type_contrat}
                        options={typeOfContractOptions}
                        onChange={(e) =>
                            setNewContract((prev) => ({
                                ...prev,
                                type_contrat: e.value,
                            }))
                        }
                        placeholder="Type de contrat"
                    />
                </Col>
            </Row>

            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold">
                        <Langs str="RESPONSABLE_CONTRACTUEL" />
                    </label>
                </Col>
                <Col lg={9} className="mb-1 pe-3">
                    <Dropdown
                        className={styles.dropdown}
                        filter
                        id="responsable_contractuel"
                        value={newContract.responsable_contractuel}
                        options={allCollabs}
                        onChange={(e) =>
                            setNewContract((prev) => ({
                                ...prev,
                                responsable_contractuel: e.value
                            }))
                        }
                        placeholder="Sélectionner un responsable"
                    />
                </Col>
            </Row>

            <Row className="p-fluid py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="START_DATE" /></label>
                </Col>
                <Col lg={9} className="mb-1 pe-3">
                    <Calendar
                        id="entree_date"
                        value={newContract.entree_date}
                        onChange={handleEntreeDateChange}
                        dateFormat="dd/mm/yy"
                        showIcon
                    />
                </Col>
            </Row>
            <Row className="p-fluid py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold">
                        <Langs str="END_DATE" />
                    </label>
                </Col>
                <Col lg={9} className="mb-1 pe-3">
                    <Calendar
                        id="sortie_date"
                        value={newContract.sortie_date}
                        onChange={handleSortieDateChange}
                        dateFormat="dd/mm/yy"
                        showIcon
                        disabled={!newContract?.entree_date}
                        minDate={newContract?.entree_date}
                    />
                </Col>
            </Row>
        </Dialog>
    )
}